import React, { PureComponent } from 'react';
import { authToken } from '../actions/utils';
import { FetchCurrency } from '../actions/currency';
import { NewBooking, UpdateBookingStatus, AddSector } from '../actions/booking';
import { AddPassenger } from '../actions/passenger';
import { withApollo } from 'react-apollo'; 
import { GetCities } from '../actions/cities';
import SearchWidget from './search/search-widget';
import { connect } from 'react-redux';
import _once from 'lodash/once';
import { SetLoading } from '../actions/utils';
import { bindActionCreators } from 'redux';

class App extends PureComponent {

    constructor(props){
        super(props);
        this.state = {
            activeCity:""
        }
        this.cityClicked = this.cityClicked.bind(this);
        this.startDateClicked = this.startDateClicked.bind(this);
    }

    componentDidMount(){
        this.init();
        document.body.addEventListener('CITY_CLICK', this.cityClicked);
        document.body.addEventListener('CITY_START_DATE_CLICK', _once(this.startDateClicked));
    }

    componentWillUnmount(){
        document.body.removeEventListener('CITY_CLICK', this.cityClicked);
        document.body.removeEventListener('CITY_START_DATE_CLICK', this.startDateClicked);
    }

    async init(){

        try{
            
            const { client } = this.props;

            //Get auth token
            await authToken();

            //Get cities list
            await GetCities(client, "CYO");

        }catch(e){}

    }

    async startDateClicked(e){

        const { client, SetLoading } = this.props;
        const { activeCity } = this.state;

        SetLoading(true);

        //Get currency code 
        const currencyCode = await FetchCurrency();

        //Create a new booking / Update booking status / Set 1 passenger
        const response = await NewBooking(client, currencyCode.data.currency_info.iso_currency_code, 'planner');
        await UpdateBookingStatus(client, response.data.newBooking.uuid, 'build');
        await AddPassenger(client, response.data.newBooking.uuid, 1);
 
        //Add sector and toggle to builder view
        await AddSector(client, response.data.newBooking.uuid, "CYO", "start", activeCity, 0, e.detail, activeCity);

        window.location.href = `${process.env.REACT_APP_PLANNER_URL}${process.env.REACT_APP_BUILDER_PAGE}?id=${response.data.newBooking.uuid}`;

    }


    cityClicked(e){
        //save active city
        this.setState({activeCity: e.detail });
    }



    render(){
        return <SearchWidget isAdventurePlanner={true} /> 
    }
}



const mapStateToProps = state => {
    return{
        uuid:state.currentBooking.uuid
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        SetLoading
    }, dispatch);
}
  
export default withApollo(connect(mapStateToProps, mapDispatchToProps)(App));


